export function isTin(tinString: string | undefined): boolean {
    const tin = tinString || '';
    return tin.match(/^\d\d\-\d\d\d\d\d\d\d$/g) !== null || tin.match(/^\d\d\d\-\d\d\-\d\d\d\d$/g) !== null;
}
